module.exports = __webpack_public_path__ + "static/img/logo11.1d0ef24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo11.png
// module id = zxUT
// module chunks = 1